import {
    WishlistDispatcher as SourceWishlistDispatcher
} from 'SourceStore/Wishlist/Wishlist.dispatcher';

/**
 * Override to disable wishlist
 */
/** @namespace Scandipwa/Store/Wishlist/Dispatcher/isWishlistEnabled */
export const isWishlistEnabled = () => false;

/**
 * Override methods to disable wishlist functionality
 */
/** @namespace Scandipwa/Store/Wishlist/Dispatcher */
export class WishlistDispatcher extends SourceWishlistDispatcher {
    updateInitialWishlistData() {
        return false;
    }

    _syncWishlistWithBE() {
        return false;
    }

    async addItemToWishlist() {
        return false;
    }

    updateWishlistItem() {
        return false;
    }

    clearWishlist() {
        return false;
    }

    async moveWishlistToCart() {
        return false;
    }

    async removeItemFromWishlist() {
        return false;
    }

    removeItemsFromWishlist() {
        return false;
    }

    resetWishlist() {
        return false;
    }
}

export default new WishlistDispatcher();
